import { api } from "./client";
import { AutoImportItem } from "../types/gordost";

export interface AutoImportsResponse {
  items: AutoImportItem[];
  total: number;
}

export async function getAutoImports(
  student_id: number,
  year_id?: number
): Promise<AutoImportsResponse> {
  const { data } = await api.get(`/auto-imports/${student_id}`, {
    params: { year_id },
  });
  return data;
}
